import { Button } from "@/components/ui/button"

export default function SalesforceLoginButton() {
  return (
    <form action="/auth/salesforce" method="post" data-turbo="false">
      <input
        type="hidden"
        name="authenticity_token"
        value={
          document
            .querySelector<HTMLMetaElement>('meta[name="csrf-token"]')
            ?.getAttribute("content") ?? ""
        }
      />
      <Button
        type="submit"
        size="lg"
        color="secondary"
        iconLeading={SalesforceIcon}
        className="w-full"
      >
        Sign in with Salesforce
      </Button>
    </form>
  )
}

function SalesforceIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
    >
      <path d="M10.05 3.75a4.72 4.72 0 0 1 3.55 1.6 5.3 5.3 0 0 1 3.9-1.72 5.37 5.37 0 0 1 5.37 5.37 5.32 5.32 0 0 1-.5 2.25 4.45 4.45 0 0 1-2.07 8.5 4.4 4.4 0 0 1-2.1-.52 5.13 5.13 0 0 1-4.2 2.18 5.1 5.1 0 0 1-4.48-2.65 4.18 4.18 0 0 1-.72.06 4.22 4.22 0 0 1-4.02-5.5A4.71 4.71 0 0 1 3 9.03a4.72 4.72 0 0 1 7.05-5.28Z" />
    </svg>
  )
}
